/**
 * Ensure all parent categories in a path are expanded, collapsing all others
 * @param {string|array} path - The path to expand
 * @param {Function} setExpandedCategories - The state setter for expandedCategories
 */
export const expandCategoryPath = (path, setExpandedCategories) => {
  if (!path) return

  const newExpandedCategories = {}
  const pathSegments = typeof path === "string" ? path.split("/") : path

  let currentPath = ""
  for (const segment of pathSegments) {
    if (segment) {
      currentPath = currentPath === "" ? segment : `${currentPath}/${segment}`
      if (currentPath) {
        newExpandedCategories[currentPath] = true
      }
    }
  }

  setExpandedCategories(newExpandedCategories)
}

/**
 * Extract published root categories from any supported TOC payload shape
 * @param {array|object} rootCategoriesData - Array, { content }, or { toc }
 * @returns {array}
 */
export const getPublishedCategories = (rootCategoriesData) => {
  if (!rootCategoriesData) return []

  let categories = []
  if (Array.isArray(rootCategoriesData)) {
    categories = rootCategoriesData
  } else if (Array.isArray(rootCategoriesData.content?.categories)) {
    categories = rootCategoriesData.content.categories
  } else if (Array.isArray(rootCategoriesData.toc?.content?.categories)) {
    categories = rootCategoriesData.toc.content.categories
  }

  return categories.filter((category) => {
    const status = category.status || category.content?.status
    return !status || status === "published"
  })
}
